import styled from "styled-components";
import * as FaIcons from "react-icons/fa";
import { TopbarData, TopbarDataCollapse } from "./TopbarData";
import Menus from "./Menus";
import { IconContext } from "react-icons/lib";
import i18n from "i18n-react";
import { useEffect, useState } from "react";
import axios from 'axios';
import { DefaultAjax } from "./DefaultAjax";
import 'react-tooltip/dist/react-tooltip.css';
import moment from 'moment';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import PropTypes from 'prop-types';
const url = process.env.REACT_APP_API_URL;

const getTokenFromCurrentUrl = () => {
    let params = window.location.href.split("?token=");
    if (params.length > 1 && params[1]) {
        return decodeURIComponent(params[1].split("&")[0]);
    }
    return localStorage.getItem('auth_token') || "";
};

const getActiveTopbarItemId = (currentModule) => {
    if (currentModule === "ordersDashboard") {
        return "ordersPlatform";
    }

    return "";
};

const markActiveTopbarItem = (items, currentModule) => {
    const activeItemId = getActiveTopbarItemId(currentModule);

    if (!activeItemId) {
        return items;
    }

    return items.map(item => {
        if (item.id !== activeItemId) {
            return item;
        }

        return {
            ...item,
            className: item.className ? `${item.className} active` : "active"
        };
    });
};

const Nav = styled.div`
    background: #15171c;
    height: 80px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    `;

const Topbar = ({ isInvoiceShow }) => {
    const [topbarData, setTopbarData] = useState([]);
    const [topbarDataCollapse, setTopbarDataCollapse] = useState([]);
    const [iconCollapseModules, setIconCollapseModules] = useState("");
    const [serviceName, setServiceName] = useState("");
    const [userFullName, setUserFullName] = useState("");
    const [username, setUsername] = useState("");
    const [ajaxFlag, setAjaxFlag] = useState(false);
    const [platformUrl, setPlatformUrl] = useState("");
    const [pathRoot, setPathRoot] = useState("");
    const [token, setToken] = useState("");
    const [maxElement, setMaxElement] = useState("");
    const [instanceType, setInstanceType] = useState("");
    const [independent, setIndependent] = useState("");
    const [currentModule, setCurrentModule] = useState("");
    const [defaultCountryCenter, setDefaultCountryCenter] = useState("");
    const [userId, setUserId] = useState("");
    const [notificationsCount, setNotificationsCount] = useState("");
    const [eventList, setEventList] = useState([]);
    const [isOpenModalNotification, setIsOpenModalNotification] = useState(false);
    const [startDate, setStartDate] = useState(moment().add(-12, 'hour'));
    const [endDate, setEndDate] = useState(moment().add(12, 'hour'));
    const [dateRange, setDateRange] = useState([]);
    const [isAdmin, setIsAdmin] = useState("");
    const [isSupervisor, setIsSupervisor] = useState("");
    const [isSupportImpersonation, setIsSupportImpersonation] = useState(false);

    const getCurrentNotification = async () => {
        // Esperar hasta que el token tenga un valor
        let tokenValue = document.querySelector("#token").value;

        // Si el token no está disponible, espera un momento y vuelve a comprobar
        while (!tokenValue) {
            await new Promise(resolve => setTimeout(resolve, 100)); // Espera 100 ms
            tokenValue = document.querySelector("#token").value;
        }

        // Luego, realiza la solicitud Ajax
        try {
            const res = await DefaultAjax('').get("/adminNotifications/reloadEventNotifications");

            if (res) {
                let data = JSON.parse(res.data);
                if (data.total !== 0) {
                    setNotificationsCount(data.total);
                    document.querySelector("#notificationCount").style.display = '';
                    if (data.total > 9) {
                        document.querySelector("#notificationCount").style.paddingTop = "8px";
                        document.querySelector("#notificationCount").style.paddingBottom = "8px";
                    }
                } else {
                    document.querySelector("#notificationCount").style.display = 'none';
                    document.querySelector("#notificationsCount").style.display = 'none';
                }
            }
        } catch (error) {

        }
    };

    useEffect(() => {
        if (!ajaxFlag) {
            axios.get(url + "globalConfig.json").then(response => {
                setPathRoot(response.data.pathRoot);
                let currentUrl = window.location.href;
                let params = currentUrl.split("?token=");
                let modules = params[0].split("?module=");
                setCurrentModule(modules[1]);
                let token = getTokenFromCurrentUrl();
                setInstanceType(response.data.instanceType);
                setIndependent(response.data.independent);
                setPlatformUrl(response.data.platformUrl);
                if (token) {
                    localStorage.setItem('auth_token', token);
                }
                setToken(token)
                axios({
                    method: 'GET',
                    url: url + "session/validateTokenForPlatform?token=" + token,
                    headers: { 'Authorization': token },
                    transformResponse: [(data) => {
                        let maxWidth = document.querySelector("#nav-tab")?.clientWidth || window.innerWidth || 0;
                        let maxElement = Math.floor(maxWidth / 150);
                        setMaxElement(maxElement);
                        let result = data.split("|");
                        setUserId(result[0])
                        setUsername(result[1])
                        setServiceName(result[5]);
                        if (result?.[6]) {
                            setUserFullName(result[6]);
                        }
                        setDefaultCountryCenter(result[8])
                        setIsSupportImpersonation(result?.[9] === "true");
                        let roles = result[4].split(",");
                        let rolesToHaveUser = roles;
                        setTopbarDataCollapse(markActiveTopbarItem(TopbarDataCollapse(rolesToHaveUser), modules[1]));

                        let roleSet = new Set(rolesToHaveUser);
                        setIsAdmin(roleSet.has("ROLE_CMP_ADMIN"))
                        setIsSupervisor(roleSet.has("ROLE_MP_SUPERVISOR"))

                        setTopbarData(markActiveTopbarItem(TopbarData(rolesToHaveUser), modules[1]));
                        let dateRange = [];
                        dateRange.push(dateRangeForSearh(new Date(moment().add(-12, 'hour'))));
                        dateRange.push(dateRangeForSearh(new Date(moment().add(12, 'hour'))));
                        setDateRange(dateRange);
                    }]
                })
                setAjaxFlag(true);
            })
        }

    }, [ajaxFlag]);

    const refreshToken = () => {
        DefaultAjax('').get('/session/refreshToken')
            .then((res) => {
                if (res) {
                    setToken(res.data);
                    document.querySelector("#token").value = res.data;
                localStorage.setItem('auth_token', res.data);
                }
            })
    }

    useEffect(() => {
        const getNotifications = () => {
            getCurrentNotification();
        };

        const refreshTokenInterval = () => {
            refreshToken();
        };

        getNotifications();
        const notificationInterval = setInterval(getNotifications, 300000);
        const tokenRefreshId = setInterval(refreshTokenInterval, 1800000);

        // Registro de funciones globales para HTML inyectado (Vanilla JS)
        window.showNotificationTemplateDetailNotLegacy = function (id, read, typeNotification) {
            const detailDiv = document.querySelector("#notificationDetail-" + id);
            const row = document.querySelector("#notificationTemplateRow-" + id);
            const preview = document.querySelector("#bodyPreview-" + id);

            if (!detailDiv) return;

            if (detailDiv.style.display === "none" || window.getComputedStyle(detailDiv).display === "none") {
                document.querySelectorAll(".notification-detail-pane").forEach(el => el.style.display = "none");
                document.querySelectorAll(".notification-item").forEach(el => el.classList.remove("eventNotificationRowOpen"));
                document.querySelectorAll(".notification-body-preview").forEach(el => el.style.display = "");

                detailDiv.style.display = "block";
                row && row.classList.add("eventNotificationRowOpen");
                preview && (preview.style.display = "none");

                if (detailDiv.textContent.trim() === 'Cargando...') {
                    DefaultAjax('').get('adminNotifications/getNotificationTemplateDetail', {
                        params: { id: id, read: read, typeNotification: typeNotification }
                    }).then(res => {
                        if (res) {
                            detailDiv.innerHTML = res.data;
                            if (read === 'false' || read === false) {
                                row && row.classList.remove('unread');
                            }
                        }
                    });
                } else if (read === 'false' || read === false) {
                    DefaultAjax('').get('adminNotifications/getNotificationTemplateDetail', {
                        params: { id: id, read: read, typeNotification: typeNotification }
                    }).then(res => {
                        if (res) {
                            row && row.classList.remove('unread');
                        }
                    });
                }
            } else {
                detailDiv.style.display = "none";
                row && row.classList.remove("eventNotificationRowOpen");
                preview && (preview.style.display = "");
            }
        };

        if (typeof window.showEventNotificationDetail === 'undefined') {
            window.showEventNotificationDetail = function (id, read) {
                const detailDiv = document.querySelector("#eventNotificationRowDetail-" + id);
                const row = document.querySelector("#eventNotificationRow-" + id);

                if (!detailDiv) return;

                if (detailDiv.style.display === "none" || window.getComputedStyle(detailDiv).display === "none") {
                    document.querySelectorAll(".notification-detail-pane").forEach(el => el.style.display = "none");
                    document.querySelectorAll(".eventNotificationRowOpen").forEach(el => el.classList.remove("eventNotificationRowOpen"));
                    detailDiv.style.display = "block";
                    row && row.classList.add("eventNotificationRowOpen");
                } else {
                    detailDiv.style.display = "none";
                    row && row.classList.remove("eventNotificationRowOpen");
                }
            };
        }

        return () => {
            clearInterval(notificationInterval);
            clearInterval(tokenRefreshId);
        };
    }, []);







    const indexEventNotifications = (event) => {
        setIsOpenModalNotification(false);
        event.stopPropagation();
        document.querySelector("#dateInInputStart").value = dateRange[0];
        document.querySelector("#dateInInputEnd").value = dateRange[1];
        document.querySelector("#notificationCount").style.display = 'none';
        DefaultAjax('').get("/adminNotifications/getEventsForNotifyWeb?dateFrom=" + dateRange[0] + "&dateTo=" + dateRange[1])
            .then((res) => {
                if (res) {
                    setEventList(res);
                    setIsOpenModalNotification(true);
                }
            }).catch((error) => {

            });
    }

    const showUserInfo = () => {
        if (document.querySelector(".dropdown-menu").style.display === "block") {
            document.querySelector(".dropdown-menu").style.display = "none";
        } else {
            document.querySelector(".dropdown-menu").style.display = "block";
        }
    }

    const userPreferences = (e) => {
        if (e.target.id === "indexConfig" || e.target.id === "userConfiguration") {
            window.location.href = platformUrl + pathRoot + "login/receiptTokenFromAppWeb?tokenOfUser=" + token + "&urlToRedirect=/html/dashboardMain.html?lang=es?module=userConfigs";
        } else if (e.target.id === "indexTickets" || e.target.id === "userTickets") {
            window.location.href = platformUrl + pathRoot + "login/receiptTokenFromAppWeb?tokenOfUser=" + token + "&urlToRedirect=/html/dashboardMain.html?lang=es?module=userTickets";
        } else if (e.target.id === 'tutorialVideos') {
            let currentUrl = window.location.origin;
            window.open(currentUrl + "?module=tutorialVideos?token=" + token, '_blank');
        }
    }

    const handleCallback = (start, end) => {
        setDateRange("");
        let dateRange = [];
        document.querySelector("#dateInInputStart").value = dateRangeForSearh(start._d);
        document.querySelector("#dateInInputEnd").value = dateRangeForSearh(end._d);
        dateRange.push(dateRangeForSearh(start._d));
        dateRange.push(dateRangeForSearh(end._d));
        setDateRange(dateRange);
        setStartDate(start._d);
        setEndDate(end._d);
    }

    const dateRangeForSearh = (date) => {
        let startDate = new Date(date);
        let m = startDate.getMonth() + 1;
        let mes = (m < 10) ? '0' + m : m;
        let day = startDate.getDate();
        let dayForShow = (day < 10) ? '0' + day : day;
        startDate = dayForShow + "-" + mes + "-" + startDate.getFullYear();
        return startDate;
    }

    return (
        <IconContext.Provider value={{ color: "#fff" }}>
            <input type="hidden" id="dateInInputStart" />
            <input type="hidden" id="dateInInputEnd" />
            <Modal isOpen={isOpenModalNotification}
                modalTransition={{ timeout: 0 }} backdropTransition={{ timeout: 0 }}
                style={{ maxWidth: '600px' }}>
                <ModalHeader className='modalHeader'>
                    {i18n.translate("notifications")}
                    <button className='close' data-dismiss="close" onClick={() => setIsOpenModalNotification(false)}>x</button>
                </ModalHeader>
                <ModalBody className={'modalBody modalWithOptionsItem'} style={{ height: '500px', overflowY: 'auto' }}>
                    <>
                        <br></br>
                        <div className="row">
                            <div className="col">
                                <DateRangePicker
                                    initialSettings={{ startDate: startDate, endDate: endDate }}
                                    onCallback={handleCallback}
                                >
                                    <input type="text" readOnly style={{ fontSize: "12px", padding: "5px", cursor: "pointer" }} className="form-control inputStandard" />
                                </DateRangePicker>
                            </div>
                            <div className="col">
                                <button className="buttonMzateSecondary" onClick={indexEventNotifications}>
                                    {i18n.translate("default_search")}
                                    <FaIcons.FaSearch style={{ color: 'black', marginLeft: '10px' }} />
                                </button>
                            </div>
                        </div>
                        <hr></hr>
                        <div
                            style={{ textAlign: 'center' }}
                            dangerouslySetInnerHTML={{ __html: eventList.data }}
                        />
                    </>
                </ModalBody>
                <ModalFooter>
                    <button className="buttonMzatePrimary" onClick={() => setIsOpenModalNotification(false)}>{i18n.translate("default_accept")}</button>
                </ModalFooter>
            </Modal>
            <Nav id="nav-top" style={{ display: isInvoiceShow ? 'none' : '' }}>
                <input type="hidden" id="token" value={token} />
                <input type="hidden" id="instanceType" value={instanceType} />
                <input type="hidden" id="independent" value={independent} />
                <input type="hidden" id="platformUrl" value={platformUrl} />
                <input type="hidden" id="pathRoot" value={pathRoot} />
                <input type="hidden" id="currentModule" value={currentModule} />
                <input type="hidden" id="defaultCountryCenter" value={defaultCountryCenter} />
                <input type="hidden" id="userFullname" value={userFullName} />
                <input type="hidden" id="username" value={username} />
                <input type="hidden" id="userId" value={userId} />
                <input type="hidden" id="isAdmin" value={isAdmin} />
                <input type="hidden" id="isSupervisor" value={isSupervisor} />
                <input type="hidden" id="isSupportImpersonation" value={isSupportImpersonation} />
                <div className="nav nav-tabs nav-fill fixed-top" id="nav-tab" role="tablist">
                    {topbarData.map((item, index) => {
                        return (
                            <>
                                {index <= maxElement &&
                                    <Menus item={item} index={index} platformUrl={platformUrl} pathRoot={pathRoot} token={token} />
                                }
                            </>
                        );
                    })}
                    {topbarDataCollapse.length > maxElement + 1 &&
                        <li className="nav-item dropdown dropdownModulesCollapse"
                            onMouseEnter={() => setIconCollapseModules("dropdown-modulesCollapseShow")}
                            onMouseLeave={() => setIconCollapseModules("")}
                        >
                            <a>
                                <FaIcons.FaBars style={{ color: 'black', fontSize: '35px' }} />
                            </a>
                            <div className={'dropdown-modulesCollapse ' + iconCollapseModules}>
                                {topbarDataCollapse.map((item, index) => {
                                    return (
                                        <>
                                            {index > maxElement &&
                                                <Menus item={item} index={index} platformUrl={platformUrl} pathRoot={pathRoot} token={token} />
                                            }
                                        </>
                                    )
                                })}
                            </div>
                        </li>
                    }

                </div>
                <li className="nav-item dropdown" id="nav-user" onClick={showUserInfo}>
                    <a className="nav-link dropdown-toggle" id="nav-usuario-tab" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                        <div id="userInfoContainer">
                            <div id="userIcon">
                                <FaIcons.FaUserCircle />
                                <span id="notificationCount" style={{ display: 'none' }} onClick={indexEventNotifications}>{notificationsCount}</span>
                            </div>
                            <div id="userInfo">
                                <div id="userName">
                                    {i18n.translate("hello")}, {userFullName}
                                </div>
                                <div id="serviceName">
                                    {serviceName}
                                </div>
                            </div>

                        </div>
                    </a>
                    <div className="dropdown-menu">
                        <a className="dropdown-item" id="indexConfig" onClick={userPreferences}>
                            <FaIcons.FaCog className="noPointerEvents" />
                            <span id="userConfiguration" className="noPointerEvents">{i18n.translate("user_configuration")}</span>
                        </a>
                        <a class="dropdown-item" id="indexEventNotifications" onClick={indexEventNotifications}>
                            <FaIcons.FaBell />
                            <span>{i18n.translate("notifications")}</span>
                            <span className='bolder' style={{ color: 'black' }} id="notificationsCount">({notificationsCount})</span>
                        </a>
                        <a className="dropdown-item" id="indexTickets" onClick={userPreferences}>
                            <FaIcons.FaQuestionCircle className="noPointerEvents" />
                            <span id="userTickets" className="noPointerEvents">{i18n.translate("tickets_title")}</span>
                        </a>
                        <a className="dropdown-item" id="tutorialVideos" onClick={userPreferences}>
                            <FaIcons.FaPlay className="noPointerEvents" />
                            <span id="userTickets" className="noPointerEvents">{i18n.translate("tutorial_videos")}</span>
                        </a>
                        <div className="dropdown-divider"></div>
                        <a className="dropdown-item" id="logout" href={platformUrl + pathRoot + "logout"}>
                            <FaIcons.FaSignOutAlt />
                            <span id="userOut">{i18n.translate("sign_off")} </span>
                        </a>
                    </div>
                </li>
            </Nav>

        </IconContext.Provider>
    );
};

Topbar.propTypes = {
    isInvoiceShow: PropTypes.bool.isRequired
};

export default Topbar;
